import React, { useEffect, useRef, useState } from "react";
import { NavLink, Link, useNavigate, useLocation } from "react-router-dom";
import useConfigurations from "useConfigurations";

const Header = () => {
  const navigate = useNavigate();
  const subMenuRef = useRef(null);
  const subMenuRefmodel = useRef(null);
  const overlay = useRef(null);
  const headerFixedRef = useRef(null);
  const [userToken, setUserToken] = useState(null);
  const [userName, setUserName] = useState();
  const [isHovered, setIsHovered] = useState(false);
  const [configrations, setConfigrations] = useState({});
  const { showPricingPlan } = useConfigurations();

  useEffect(() => {
    const domain = window.location.origin;

    setConfigrations({
      domain: domain,
    });
  }, []);

  function handleScroll() {
    var element = document.getElementById("header");
    if (window.scrollY > 72) {
      if (headerFixedRef.current) {
        headerFixedRef.current.classList.add("header__fixed");
      }
    } else {
      if (element) {
        element.classList.remove("header__fixed");
      }
    }
  }

  const handleClick = () => {
    subMenuRef.current.classList.add("one");
    subMenuRef.current.classList.remove("two");
  };

  const handleClickmodile = () => {
    subMenuRefmodel.current.classList.add("one");
    overlay.current.classList.add("one");
    subMenuRefmodel.current.classList.remove("two");
    overlay.current.classList.remove("two");
  };
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    const storedUserToken = localStorage.getItem("Userkey");
    setUserToken(storedUserToken);
    if (storedUserToken) {
      const storedDataUser = localStorage.getItem("DataUser");
      if (storedDataUser != null) {
        const atobDataUser = atob(storedDataUser);
        const parsedDataUser = JSON.parse(atobDataUser);
        setUserName(parsedDataUser.name);
      } else {
        localStorage.clear();
      }
    }

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const location = useLocation();

  useEffect(() => {
    // Check if the current location is "/customers"
    const isCustomersPage = location.pathname === "/customers";
    const isEnterprisePage = location.pathname === "/enterprise";
    const isCheoutPage = location.pathname === "/Chekout";
    const issolutionPage = location.pathname === "/solution";
    const isManageAccountPage = location.pathname === "/ManageAccount";
    const isApss = location.pathname === "/Apps";

    // Add or remove the class based on the condition
    const headerElement = document.querySelector("header");
    if (headerElement) {
      if (
        isCustomersPage ||
        isEnterprisePage ||
        isCheoutPage ||
        issolutionPage ||
        isManageAccountPage ||
        isApss
      ) {
        headerElement.classList.add("white_header"); // Add the class
      } else {
        headerElement.classList.remove("white_header"); // Remove the class
      }
    }
  }, [location.pathname]);

  const handleLogout = () => {
    // Simulate a logout action and remove the user token from local storage
    setUserToken(null);
    localStorage.removeItem("Userkey");

    navigate("/");
  };
  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };
  const subDomain = `${configrations.domain}/accounts`;

  return (
    <header className="header" ref={headerFixedRef} id="header">
      <nav className="navbar navbar-expand-lg order-lg-0 order-1">
        <div className="collapse navbar-collapse wrapper">
          <ul className="navbar-nav d-none d-lg-flex">
            <li className="nav-item">
              <NavLink className="nav-link resources" to={"/"}>
                <span>Home</span>
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink className="nav-link company" to={"/company"}>
                <span>Company</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="arrow templat-none"
                  width={16}
                  height={16}
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.4889 7C11.1538 7 11.0899 7.51535 10.7484 7.92614C10.3085 8.45519 9.03834 9.99393 8.7031 10.3442C8.18538 10.8851 7.94988 10.8854 7.43109 10.3442L5.22727 7.92614C4.89955 7.53947 4.88615 7 5.45432 7C7.4229 7 9.90105 7 10.4889 7Z"
                    fill="#556068"
                  />
                </svg>
              </NavLink>
              <div className="company_menu templat-none">
                <ul className="company_list">
                  <li>
                    <NavLink to={"/company"} className="dropdown-item">
                      <img
                        src="/assets/images/icons/Careers.svg"
                        className="icon"
                        alt="Careers"
                      />
                      <span>Careers</span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to={"/company"} className="dropdown-item">
                      <img
                        src="/assets/images/icons/About.svg"
                        className="icon"
                        alt="About"
                      />
                      <span>About</span>
                    </NavLink>
                  </li>
                  <li>
                    <a href={`${subDomain}/contact`} className="dropdown-item">
                      <img
                        src="/assets/images/icons/ContactUs.svg"
                        className="icon"
                        alt="ContactUs"
                      />
                      <span>Contact us</span>
                    </a>
                  </li>
                </ul>
              </div>
            </li>
            <li className="nav-item">
              <div
                className="nav-link products"
                onMouseEnter={() => {
                  subMenuRef.current.classList.remove("one");
                  subMenuRef.current.classList.add("two");
                }}
              >
                <span>Products</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="arrow"
                  width={16}
                  height={16}
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.4889 7C11.1538 7 11.0899 7.51535 10.7484 7.92614C10.3085 8.45519 9.03834 9.99393 8.7031 10.3442C8.18538 10.8851 7.94988 10.8854 7.43109 10.3442L5.22727 7.92614C4.89955 7.53947 4.88615 7 5.45432 7C7.4229 7 9.90105 7 10.4889 7Z"
                    fill="#556068"
                  />
                </svg>
              </div>
              <div className="menu one" ref={subMenuRef}>
                <ul className="parent">
                  <li className="menu__item title">
                    <span>ALL PRODUCTS</span>
                  </li>
                  <li className="menu__item menu__item--sub">
                    <Link className="menu__link menu__link--sub">
                      <span>Construction Management</span>
                      <img
                        src="/assets/images/icons/langChevroRight.svg"
                        className="arrow"
                        alt="arrow"
                      />
                    </Link>
                    <div className="sub-menu">
                      <div className="child">
                        <div className="sub-menu--head">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="icon"
                            width={16}
                            height={16}
                            viewBox="0 0 16 16"
                            fill="none"
                          >
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M8.56974 4.94072L11.4527 7.82821L2 7.82821V9.17184H11.4527L8.56974 12.0593L9.50872 13L14 8.5L9.50872 4L8.56974 4.94072Z"
                              fill="#B1C2C9"
                            />
                          </svg>
                          <h3 className="title">Construction Management</h3>
                        </div>
                        <div className="row products">
                          <div className="col-lg-6 p-0">
                            <NavLink
                              to={"/pm"}
                              className="product"
                              onClick={handleClick}
                            >
                              <div className="img">
                                <img
                                  src="/assets/images/icons/ProjectManagement.svg"
                                  className="icon"
                                  alt="Project Management"
                                />
                              </div>
                              <div className="info">
                                <h4 className="info__title text-truncate">
                                  Project Management
                                </h4>
                                <p className="info__desc">
                                  Manage projects efficiently with real-time
                                  tracking and collaboration tools.
                                </p>
                              </div>
                            </NavLink>
                          </div>
                          <div className="col-lg-6 p-0">
                            <NavLink
                              to={"/contract"}
                              className="product"
                              onClick={handleClick}
                            >
                              <div className="img">
                                <img
                                  src="/assets/images/icons/ContractManagement.svg"
                                  className="icon"
                                  alt="Contract management"
                                />
                              </div>
                              <div className="info">
                                <h4 className="info__title text-truncate">
                                  Contract Management
                                </h4>
                                <p className="info__desc">
                                  Simplify contract workflows and ensure
                                  compliance at every stage.
                                </p>
                              </div>
                            </NavLink>
                          </div>
                          <div className="col-lg-6 p-0">
                            <NavLink
                              to={"/procurement"}
                              className="product"
                              onClick={handleClick}
                            >
                              <div className="img">
                                <img
                                  src="/assets/images/icons/procurment.svg"
                                  className="icon"
                                  alt="Procurement"
                                />
                              </div>
                              <div className="info">
                                <h4 className="info__title text-truncate">
                                  Procurement
                                </h4>
                                <p className="info__desc">
                                  Streamline procurement to reduce costs and
                                  improve supplier management.
                                </p>
                              </div>
                            </NavLink>
                          </div>
                          <div className="col-lg-6 p-0">
                            <NavLink
                              to={"/cost-management"}
                              className="product"
                              onClick={handleClick}
                            >
                              <div className="img">
                                <img
                                  src="/assets/images/icons/constMangment.svg"
                                  className="icon"
                                  alt="Cost management"
                                />
                              </div>
                              <div className="info">
                                <h4 className="info__title text-truncate">
                                  Cost Management
                                </h4>
                                <p className="info__desc">
                                  Control project budgets and monitor expenses
                                  in real time.
                                </p>
                              </div>
                            </NavLink>
                          </div>
                          <div className="col-lg-6 p-0">
                            <NavLink
                              to={"/estimation"}
                              className="product"
                              onClick={handleClick}
                            >
                              <div className="img">
                                <img
                                  src="/assets/images/icons/EstimationManagement.svg"
                                  className="icon"
                                  alt="Estimation management"
                                />
                              </div>
                              <div className="info">
                                <h4 className="info__title text-truncate">
                                  Estimation Management
                                </h4>
                                <p className="info__desc">
                                  Create accurate project estimates for better
                                  bidding and planning.
                                </p>
                              </div>
                            </NavLink>
                          </div>
                          <div className="col-lg-6 p-0">
                            <NavLink
                              to={"/quality"}
                              className="product"
                              onClick={handleClick}
                            >
                              <div className="img">
                                <img
                                  src="/assets/images/icons/QualityControl.svg"
                                  className="icon"
                                  alt="Quality Control"
                                />
                              </div>
                              <div className="info">
                                <h4 className="info__title text-truncate">
                                  Quality Control
                                </h4>
                                <p className="info__desc">
                                  Ensure project quality with automated
                                  inspections and compliance tracking.
                                </p>
                              </div>
                            </NavLink>
                          </div>
                          {/* <div className="col-lg-6 p-0">
                          <NavLink to={"./equipments"} className="product" onClick={handleClick}>
                            <div className="img">
                              <img src="assets/images/icons/EquipmentManagement.svg" className="icon" alt="Equipment management" />
                            </div>
                            <div className="info">
                              <h4 className="info__title text-truncate">Equipment Management</h4>
                              <p className="info__desc">Optimize equipment usage with tracking and maintenance alerts.</p>
                            </div>
                          </NavLink>
                        </div> */}
                        </div>
                      </div>
                    </div>
                  </li>
                  <li className="menu__item ">
                    <NavLink
                      className="menu__link"
                      to={"/accounting"}
                      onClick={handleClick}
                    >
                      <span>Accounting</span>
                    </NavLink>
                  </li>
                  <li className="menu__item">
                    <NavLink
                      className="menu__link"
                      to={"/hr"}
                      onClick={handleClick}
                    >
                      <span>Human Resources</span>
                    </NavLink>
                  </li>
                  <li className="menu__item">
                    <NavLink
                      className="menu__link"
                      to={"/fm"}
                      onClick={handleClick}
                    >
                      <span>Facility Management</span>
                    </NavLink>
                  </li>
                  <li className="menu__item">
                    <NavLink
                      className="menu__link"
                      to={"/crm"}
                      onClick={handleClick}
                    >
                      <span>CRM</span>
                    </NavLink>
                  </li>
                  <li className="menu__item line_dashed" />
                  <li className="menu__item title">
                    <span>Solutions for</span>
                  </li>
                  <li className="menu__item">
                    <NavLink
                      className="menu__link"
                      to={"/solution"}
                      onClick={handleClick}
                    >
                      <span>Contractors</span>
                    </NavLink>
                  </li>
                  <li className="menu__item templat-none">
                    <NavLink className="menu__link" href="#">
                      <span>Consultants</span>
                    </NavLink>
                  </li>
                  <li className="menu__item templat-none">
                    <NavLink className="menu__link" href="#">
                      <span>Developers &amp; Owners</span>
                    </NavLink>
                  </li>
                  <li className="menu__item line_dashed" />
                  <li className="menu__item title">
                    <span>KNOW MORE</span>
                  </li>
                  <li className="menu__item templat-none">
                    <NavLink className="menu__link " href="#">
                      <img
                        src="/assets/images/icons/look.svg"
                        className="img-fluid icon"
                        alt="tour"
                      />
                      <span>Take a tour</span>
                    </NavLink>
                  </li>
                  <li className="menu__item ">
                    <NavLink
                      className="menu__link"
                      to={"/features"}
                      onClick={handleClick}
                    >
                      <img
                        src="/assets/images/icons/star.svg"
                        className="img-fluid icon"
                        alt="star"
                      />
                      <span>Features</span>
                    </NavLink>
                  </li>
                  <li className="menu__item templat-none">
                    <NavLink className="menu__link" href="#">
                      <img
                        src="/assets/images/icons/play.svg"
                        className="img-fluid icon"
                        alt="play"
                      />
                      <span>Watch a video</span>
                    </NavLink>
                  </li>
                  <li className="menu__item">
                    <NavLink
                      className="menu__link"
                      to={"/enterprise"}
                      onClick={handleClick}
                    >
                      <img
                        src="/assets/images/icons/castel.svg"
                        className="img-fluid icon"
                        alt="enterprises"
                      />
                      <span>For enterprises</span>
                    </NavLink>
                  </li>
                </ul>
              </div>
            </li>

            <li className="nav-item templat-none">
              <NavLink className="nav-link resources">
                <span>Resources</span>
              </NavLink>
            </li>
            {showPricingPlan && (
              <li className="nav-item ">
                <NavLink className="nav-link pricing" to={"/Prices"}>
                  <span>Prices</span>
                </NavLink>
              </li>
            )}
          </ul>
        </div>
        <div className="mobile-menu">
          <input
            type="checkbox"
            id="menu"
            name="menu"
            className="m-menu__checkbox"
          />
          <label
            className="m-menu__toggle"
            htmlFor="menu"
            onClick={() => {
              subMenuRefmodel.current.classList.remove("one");
              overlay.current.classList.remove("one");
              subMenuRefmodel.current.classList.add("two");
              overlay.current.classList.add("two");
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={24}
              height={24}
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1 4C0.447715 4 0 4.44772 0 5C0 5.55228 0.447716 6 1 6H23C23.5523 6 24 5.55228 24 5C24 4.44772 23.5523 4 23 4H1ZM0 12C0 11.4477 0.447715 11 1 11H23C23.5523 11 24 11.4477 24 12C24 12.5523 23.5523 13 23 13H1C0.447716 13 0 12.5523 0 12ZM0 19C0 18.4477 0.447715 18 1 18H23C23.5523 18 24 18.4477 24 19C24 19.5523 23.5523 20 23 20H1C0.447716 20 0 19.5523 0 19Z"
                fill="#fff"
              />
            </svg>
          </label>
          <label className="m-menu__overlay" htmlFor="menu" ref={overlay} />
          <div className="m-menu one" ref={subMenuRefmodel}>
            <div className="m-menu__header">
              <NavLink to={"/"} className="logo ">
                <img src="/assets/images/favIcon.svg" alt="procoor" />
              </NavLink>
              <span className="title">Hi,{userName}</span>
              {/*just for styling*/}
              <label className="m-menu__toggle" htmlFor="menu">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.70703 3.70698C4.31651 3.31646 3.69081 3.32375 3.30949 3.72327C2.92818 4.12279 2.93564 4.76325 3.32617 5.15377L10.5861 12.4137L3.70706 19.2927C3.31654 19.6832 3.30907 20.3237 3.69039 20.7232C4.0717 21.1227 4.6974 21.13 5.08793 20.7395L11.9999 13.8275L18.8825 20.7101C19.273 21.1006 19.8987 21.0934 20.2801 20.6938C20.6614 20.2943 20.6539 19.6539 20.2634 19.2633L13.4137 12.4137L20.6443 5.18313C21.0348 4.7926 21.0423 4.15215 20.6609 3.75262C20.2796 3.3531 19.6539 3.34581 19.2634 3.73633L11.9999 10.9998L4.70703 3.70698Z"
                    fill="white"
                  />
                </svg>
              </label>
            </div>
            <div className="m-menu__body">
              <ul>
                <li className="nav-item ">
                  <NavLink
                    to={"/"}
                    className="nav-link"
                    onClick={handleClickmodile}
                  >
                    <span>HOME</span>
                  </NavLink>
                </li>
                <li className="nav-item">
                  <label htmlFor="COMPANY-2">
                    <NavLink
                      to={"/company"}
                      className="nav-link"
                      onClick={handleClickmodile}
                    >
                      <span>COMPANY</span>
                    </NavLink>
                  </label>
                  <input
                    type="checkbox"
                    id="COMPANY-2"
                    name="COMPANY-2"
                    className="m-menu__checkbox "
                  />
                  <div className="m-menu templat-none">
                    <div className="m-menu__header">
                      <a href="#" className="logo ">
                        <img src="/assets/images/favIcon.svg" alt="procoor" />
                      </a>
                      <span className="title">COMPANY </span>
                      <label className="m-menu__toggle" htmlFor="COMPANY-2">
                        <img
                          src="/assets/images/icons/chevroRight.svg"
                          alt="back"
                        />
                      </label>
                    </div>
                    <div className="m-menu__body ">
                      <ul className="company_list">
                        <li>
                          <a className="nav-link" href="#">
                            <img
                              src="/assets/images/icons/Careers-m.svg"
                              className="icon"
                              alt="Careers"
                            />
                            <span>Careers</span>
                          </a>
                        </li>
                        <li>
                          <a className="nav-link" href="#">
                            <img
                              src="/assets/images/icons/About-m.svg"
                              className="icon"
                              alt="About"
                            />
                            <span>About</span>
                          </a>
                        </li>
                        <li>
                          <a className="nav-link" href="#">
                            <img
                              src="/assets/images/icons/ContactUs-m.svg"
                              className="icon"
                              alt="ContactUs"
                            />
                            <span>Contact us</span>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </li>
                <li className="nav-item">
                  <label className="a-label__chevron" htmlFor="products">
                    <div className="nav-link">
                      <span>PRODUCTS</span>
                    </div>
                  </label>
                  <input
                    type="checkbox"
                    id="products"
                    name="products"
                    className="m-menu__checkbox"
                  />
                  <div className="m-menu">
                    <div className="m-menu__header">
                      <NavLink href="#" className="logo ">
                        <img src="/assets/images/favIcon.svg" alt="procoor" />
                      </NavLink>
                      <span className="title">Products </span>
                      <label className="m-menu__toggle" htmlFor="products">
                        <img
                          src="/assets/images/icons/chevroRight.svg"
                          alt="back"
                        />
                      </label>
                    </div>
                    <div className="m-menu__body">
                      <ul>
                        <li className="menu__item title zero">
                          <span>ALL PRODUCTS</span>
                        </li>
                        <li className="nav-item">
                          <label
                            className="a-label__chevron"
                            htmlFor="products-2"
                          >
                            <div className="nav-link">
                              <span>CONSTRUCTION MANAGEMENT</span>
                            </div>
                          </label>
                          <input
                            type="checkbox"
                            id="products-2"
                            name="products"
                            className="m-menu__checkbox"
                          />
                          <div className="m-menu">
                            <div className="m-menu__header">
                              <div href="#" className="logo ">
                                <img
                                  src="/assets/images/favIcon.svg"
                                  alt="procoor"
                                />
                              </div>
                              <span className="title">
                                CONSTRUCTION MANAGEMENT{" "}
                              </span>
                              <label
                                className="m-menu__toggle"
                                htmlFor="products-2"
                              >
                                <img
                                  src="/assets/images/icons/chevroRight.svg"
                                  alt="back"
                                />
                              </label>
                            </div>
                            <div className="m-menu__body">
                              <ul>
                                <li>
                                  <NavLink
                                    to={"/pm"}
                                    className="product"
                                    onClick={handleClickmodile}
                                  >
                                    <div className="img">
                                      <img
                                        src="/assets/images/icons/ProjectManagement.svg"
                                        className="icon"
                                        alt="Project Management"
                                      />
                                    </div>
                                    <div className="info">
                                      <h4 className="info__title text-truncate">
                                        Project Management
                                      </h4>
                                      <p className="info__desc">
                                        Manage projects efficiently with
                                        real-time tracking and collaboration
                                        tools.
                                      </p>{" "}
                                    </div>
                                  </NavLink>
                                </li>
                                <li>
                                  <NavLink
                                    to={"/contract"}
                                    className="product"
                                    onClick={handleClickmodile}
                                  >
                                    <div className="img">
                                      <img
                                        src="/assets/images/icons/ContractManagement.svg"
                                        className="icon"
                                        alt="Contract management"
                                      />
                                    </div>
                                    <div className="info">
                                      <h4 className="info__title text-truncate">
                                        Contract Management
                                      </h4>
                                      <p className="info__desc">
                                        Simplify contract workflows and ensure
                                        compliance at every stage.
                                      </p>
                                    </div>
                                  </NavLink>
                                </li>
                                <li>
                                  <NavLink
                                    to={"/procurement"}
                                    className="product"
                                    onClick={handleClickmodile}
                                  >
                                    <div className="img">
                                      <img
                                        src="/assets/images/icons/ContractManagement.svg"
                                        className="icon"
                                        alt="icon"
                                      />
                                    </div>
                                    <div className="info">
                                      <h4 className="info__title text-truncate">
                                        Procurement
                                      </h4>
                                      <p className="info__desc">
                                        Streamline procurement to reduce costs
                                        and improve supplier management.
                                      </p>
                                    </div>
                                  </NavLink>
                                </li>
                                <li>
                                  <NavLink
                                    to={"/cost-management"}
                                    className="product"
                                    onClick={handleClickmodile}
                                  >
                                    <div className="img">
                                      <img
                                        src="/assets/images/icons/constMangment.svg"
                                        className="icon"
                                        alt="Cost management"
                                      />
                                    </div>
                                    <div className="info">
                                      <h4 className="info__title text-truncate">
                                        Cost Management
                                      </h4>
                                      <p className="info__desc">
                                        Control project budgets and monitor
                                        expenses in real time.
                                      </p>
                                    </div>
                                  </NavLink>
                                </li>
                                <li>
                                  <NavLink
                                    to={"/estimation"}
                                    className="product"
                                    onClick={handleClickmodile}
                                  >
                                    <div className="img">
                                      <img
                                        src="/assets/images/icons/EstimationManagement.svg"
                                        className="icon"
                                        alt="Estimation management"
                                      />
                                    </div>
                                    <div className="info">
                                      <h4 className="info__title text-truncate">
                                        Estimation Management
                                      </h4>
                                      <p className="info__desc">
                                        Create accurate project estimates for
                                        better bidding and planning.
                                      </p>
                                    </div>
                                  </NavLink>
                                </li>
                                <li>
                                  <NavLink
                                    to={"/quality"}
                                    className="product"
                                    onClick={handleClickmodile}
                                  >
                                    <div className="img">
                                      <img
                                        src="/assets/images/icons/QualityControl.svg"
                                        className="icon"
                                        alt="Quality control"
                                      />
                                    </div>
                                    <div className="info">
                                      <h4 className="info__title text-truncate">
                                        Quality Control
                                      </h4>
                                      <p className="info__desc">
                                        Ensure project quality with automated
                                        inspections and compliance tracking.
                                      </p>
                                    </div>
                                  </NavLink>
                                </li>
                                {/* <li>
                                  <NavLink to={"/equipments"} className="product" onClick={handleClickmodile}>
                                    <div className="img">
                                      <img src="assets/images/icons/EquipmentManagement.svg" className="icon" alt="Equipment management" />
                                    </div>
                                    <div className="info">
                                      <h4 className="info__title text-truncate">Equipment Management</h4>
                                      <p className="info__desc">Alot of companies of all sizes - from small to mega ones - use
                                        Procoor’s software and APIs to coordinate.</p>
                                    </div>
                                  </NavLink>
                                </li> */}
                              </ul>
                            </div>
                          </div>
                        </li>
                        <li className="nav-item">
                          <NavLink
                            to={"/accounting"}
                            className="nav-link"
                            onClick={handleClickmodile}
                          >
                            <span>ACCOUNTING</span>
                          </NavLink>
                        </li>
                        <li className="nav-item">
                          <NavLink
                            className="nav-link"
                            to={"/fm"}
                            onClick={handleClickmodile}
                          >
                            <span>Facility Management</span>
                          </NavLink>
                        </li>
                        <li className="nav__item">
                          <NavLink
                            className="nav-link"
                            to={"/crm"}
                            onClick={handleClickmodile}
                          >
                            <span>CRM</span>
                          </NavLink>
                        </li>
                        <li className="nav-item">
                          <NavLink
                            to={"/hr"}
                            className="nav-link"
                            onClick={handleClickmodile}
                          >
                            <span>HUMAN RESOURCES</span>
                          </NavLink>
                        </li>
                        <li className="menu__item title">
                          <span>SOLUTIONS FOR</span>
                        </li>
                        <li className="nav-item">
                          <NavLink
                            className="nav-link"
                            onClick={handleClickmodile}
                            to={"/solutions"}
                          >
                            <span>CONTRACTORS</span>
                          </NavLink>
                        </li>
                        <li className="nav-item templat-none">
                          <NavLink className="nav-link">
                            <span>CONSULTANTS</span>
                          </NavLink>
                        </li>
                        <li className="nav-item templat-none">
                          <NavLink className="nav-link">
                            <span>DEVELOPERS &amp; OWNERS</span>
                          </NavLink>
                        </li>
                        <li className="menu__item title">
                          <span>KNOW MORE</span>
                        </li>
                        <li className="nav-item templat-none">
                          <NavLink
                            className="nav-link more "
                            onClick={handleClickmodile}
                            to={""}
                          >
                            <img
                              src="/assets/images/icons/look-m.svg"
                              className="img-fluid icon"
                              alt="tour"
                            />
                            <span>Take a tour</span>
                          </NavLink>
                        </li>
                        <li className="nav-item">
                          <NavLink
                            className="nav-link more"
                            onClick={handleClickmodile}
                            to={"/features"}
                          >
                            <img
                              src="/assets/images/icons/star-m.svg"
                              className="img-fluid icon"
                              alt="star"
                            />
                            <span>Features</span>
                          </NavLink>
                        </li>
                        <li className="nav-item templat-none">
                          <NavLink
                            className="nav-link more"
                            onClick={handleClickmodile}
                            to={"/solutions"}
                          >
                            <img
                              src="/assets/images/icons/play-m.svg"
                              className="img-fluid icon"
                              alt="play"
                            />
                            <span>Watch a video</span>
                          </NavLink>
                        </li>
                        <li className="nav-item">
                          <NavLink
                            className="nav-link more"
                            onClick={handleClickmodile}
                            to={"/enterprise"}
                          >
                            <img
                              src="/assets/images/icons/castel-m.svg"
                              className="img-fluid icon"
                              alt="enterprises"
                            />
                            <span>For enterprises</span>
                          </NavLink>
                        </li>
                      </ul>
                    </div>
                  </div>
                </li>
                <li className="nav-item templat-none">
                  <NavLink className="nav-link">
                    <span>RESOURCES</span>
                  </NavLink>
                </li>

                {showPricingPlan && (
                  <li className="nav-item pricing">
                    <NavLink to={"/Prices"} className="nav-link">
                      <span>Prices</span>
                    </NavLink>
                  </li>
                )}
              </ul>
            </div>
            <div className="m-menu__footer header_right">
              <div className="language templat-none">
                <p className="language__title">
                  <img
                    src="/assets/images/icons/langEarth.svg"
                    className="icon"
                    alt="language"
                  />
                  Language
                </p>
                <div className="lang">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="flexRadioDefault"
                      id="flexRadioDefault2"
                      defaultChecked
                    />
                    <label
                      className="form-check-label"
                      htmlFor="flexRadioDefault2"
                    >
                      {" "}
                      English{" "}
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="flexRadioDefault"
                      id="flexRadioDefault1"
                    />
                    <label
                      className="form-check-label"
                      htmlFor="flexRadioDefault1"
                    >
                      {" "}
                      Arabic{" "}
                    </label>
                  </div>
                </div>
              </div>
              <div className="two">
                {userToken ? (
                  <>
                    {showPricingPlan && (
                      <a
                        href={`${subDomain}/ManageAccount`}
                        className="primaryBtn-2 largeBtn btn"
                      >
                        Manage Account
                      </a>
                    )}
                    <NavLink
                      onClick={handleLogout}
                      className="primaryBtn-2 largeBtn btn"
                    >
                      logout
                    </NavLink>
                  </>
                ) : (
                  <a
                    href={`${subDomain}/login`}
                    className="primaryBtn-2 largeBtn btn"
                  >
                    Login
                  </a>
                )}

                <a
                  href={`${subDomain}/contact`}
                  className="primaryBtn-2 largeBtn btn"
                >
                  Contact Now
                </a>
              </div>

              {userToken ? null : (
                <a
                  href={`${subDomain}/CreateAccount?page=0`}
                  className="primaryBtn-1 largeBtn  icon-r btn "
                >
                  Start now
                  <img
                    src="/assets/images/icons/arrow-right16.svg"
                    className="icon"
                    alt="arrow"
                  />
                </a>
              )}
            </div>
          </div>
        </div>
      </nav>
      <NavLink to={"/"} className="logo order-lg-1 order-0">
        {/* */}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="d-none d-lg-block"
          width={134}
          height={40}
          viewBox="0 0 134 40"
          fill="none"
        >
          <path
            className="logoBG"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20 40C31.0457 40 40 31.0457 40 20C40 8.95431 31.0457 0 20 0C8.95431 0 0 8.95431 0 20C0 23.0712 0.692228 25.9806 1.92917 28.5809C2.68194 30.1634 3.63645 31.6313 4.75946 32.9515C5.23999 33.5164 5.75137 34.0543 6.291 34.5625C6.88888 35.1255 7.52144 35.6522 8.18512 36.1389C11.4955 38.5664 15.5803 40 20 40Z"
            fill="#DBE7FF"
          />
          <path
            className="logoIcon"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.1686 25.2536C13.169 23.4001 13.162 21.5467 13.1702 19.6937C13.1904 14.9587 18.272 11.6563 22.5979 13.5621C25.5282 14.8533 26.9728 17.2809 26.814 20.648C26.6927 23.2156 24.7623 25.6605 22.0385 26.4975C21.1077 26.7837 20.0855 26.8389 19.1016 26.8644C18.1045 26.8904 18.0782 26.7388 18.093 24.4632C18.0975 23.7321 18.079 23.0591 19.1304 23.1197C20.496 23.1987 21.7308 22.8907 22.5387 21.6554C23.3173 20.4639 23.2643 19.1352 22.4223 18.0054C21.7123 17.0527 20.387 16.6132 19.2016 16.9374C17.9186 17.2887 16.9713 18.3131 16.9446 19.6793C16.8825 22.8696 16.9002 26.0625 16.9549 29.2533C16.9598 29.5474 17.4168 30.0235 17.7343 30.0931C21.5507 30.9313 24.9273 29.9704 27.5791 27.1305C33.0309 21.2926 30.384 12.5097 23.3568 10.1386C17.1593 8.04746 11.179 12.0221 9.94047 17.6985C9.60482 19.2361 9.59454 20.7514 9.92648 22.2852C10.0449 22.833 10.2782 23.165 10.8836 23.1151C11.6146 23.0546 11.8396 23.4557 11.8371 24.1201C11.8268 27.2355 12.1193 26.822 9.21241 26.9176C8.04999 26.9559 7.45192 26.6045 6.99205 25.4826C3.75694 17.5931 7.78921 8.55819 16.0401 6.44032C24.8059 4.19024 32.0984 8.82549 33.9358 17.367C35.6609 25.3874 29.5716 33.2732 21.4129 33.999C18.9227 34.2205 16.5822 33.8227 14.2858 32.9207C13.4956 32.6105 13.1139 32.1472 13.1468 31.2246C13.2175 29.2364 13.1682 27.2442 13.1686 25.2536Z"
            fill="#143BFF"
          />
          <path
            className="text"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M55.1345 22.593L53.3855 20.0001H55.1274C55.8043 20.0001 56.3149 19.8533 56.6589 19.5597C57.0029 19.266 57.175 18.8478 57.175 18.3048C57.175 17.7619 57.0029 17.3408 56.6589 17.0416C56.3149 16.7424 55.8043 16.5929 55.1274 16.5929H53.2962V19.8676L53.2952 19.8662V22.9271H53.2962V25.6346H50V14H55.3271C56.3815 14 57.297 14.1745 58.0739 14.5236C58.8508 14.8726 59.4501 15.3712 59.8718 16.0194C60.2936 16.6677 60.5044 17.4294 60.5044 18.3048C60.5044 19.1802 60.2936 19.9392 59.8718 20.5819C59.4501 21.2245 58.8508 21.7204 58.0739 22.0694C57.297 22.4185 56.3815 22.593 55.3271 22.593H55.1345ZM65.0472 22.9271V25.6346H61.751V14H67.0781C68.1325 14 69.048 14.1745 69.8249 14.5236C70.6018 14.8726 71.2011 15.3712 71.6228 16.0194C72.0446 16.6677 72.2554 17.4294 72.2554 18.3048C72.2554 19.1469 72.0584 19.881 71.6644 20.5071C71.2705 21.1331 70.7072 21.6234 69.9748 21.978L72.4885 25.6346H68.9593L67.1077 22.9271H67.1108L65.1365 20.0001H66.8784C67.5554 20.0001 68.0659 19.8533 68.4099 19.5597C68.754 19.266 68.926 18.8478 68.926 18.3048C68.926 17.7619 68.754 17.3408 68.4099 17.0416C68.0659 16.7424 67.5554 16.5929 66.8784 16.5929H65.0472V19.8676L65.0462 19.8662V22.9271H65.0472ZM126.25 22.9271V25.6346H122.954V14H128.281C129.336 14 130.251 14.1745 131.028 14.5236C131.805 14.8726 132.404 15.3712 132.826 16.0194C133.248 16.6677 133.459 17.4294 133.459 18.3048C133.459 19.1469 133.262 19.881 132.868 20.5071C132.474 21.1331 131.91 21.6234 131.178 21.978L133.692 25.6346H130.162L128.311 22.9271H128.314L126.34 20.0001H128.082C128.759 20.0001 129.269 19.8533 129.613 19.5597C129.957 19.266 130.129 18.8478 130.129 18.3048C130.129 17.7619 129.957 17.3408 129.613 17.0416C129.269 16.7424 128.759 16.5929 128.082 16.5929H126.25V19.8676L126.249 19.8662V22.9271H126.25ZM92.1518 26.1C90.931 26.1 89.8351 25.8424 88.864 25.3271C87.8929 24.8119 87.1299 24.0944 86.575 23.1747C86.0201 22.255 85.7426 21.2135 85.7426 20.05C85.7426 18.8865 86.0201 17.845 86.575 16.9253C87.1299 16.0056 87.8929 15.2881 88.864 14.7729C89.8351 14.2576 90.931 14 92.1518 14C93.2173 14 94.1772 14.1884 95.0318 14.5651C95.658 14.8412 96.2067 15.2065 96.678 15.661C96.5655 15.8291 96.0279 16.6383 95.0651 18.0887C94.3104 17.1801 93.3948 16.7258 92.3183 16.7258C91.6857 16.7258 91.1225 16.8643 90.6286 17.1413C90.1347 17.4184 89.7519 17.8089 89.48 18.3131C89.208 18.8173 89.0721 19.3962 89.0721 20.05C89.0721 20.7038 89.208 21.2827 89.48 21.7869C89.7519 22.291 90.1347 22.6816 90.6286 22.9587C91.1225 23.2357 91.6857 23.3742 92.3183 23.3742C93.3948 23.3742 94.3104 22.9199 95.0651 22.0113C96.1542 23.6163 96.6971 24.4204 96.694 24.4235C96.2191 24.8852 95.6651 25.2557 95.0318 25.5349C94.1772 25.9116 93.2173 26.1 92.1518 26.1ZM78.8879 16.9333C76.5377 16.9333 75.9501 18.8658 75.9501 19.8665C75.9501 20.8672 76.5377 22.7997 78.8879 22.7997C81.2381 22.7997 81.8256 20.8394 81.8256 19.8665C81.8256 18.8936 81.2381 16.9333 78.8879 16.9333ZM78.8879 14.0002C82.6959 14.0002 84.7634 16.8701 84.7634 19.8665C84.7634 22.8629 82.6959 25.7328 78.8879 25.7328C75.0785 25.7328 73.0124 22.8811 73.0124 19.8665C73.0124 16.8519 75.0785 14.0002 78.8879 14.0002ZM102.88 16.9333C100.529 16.9333 99.9418 18.8658 99.9418 19.8665C99.9418 20.8672 100.529 22.7997 102.88 22.7997C105.23 22.7997 105.817 20.8394 105.817 19.8665C105.817 18.8936 105.23 16.9333 102.88 16.9333ZM102.88 14.0002C106.688 14.0002 108.755 16.8701 108.755 19.8665C108.755 22.8629 106.688 25.7328 102.88 25.7328C99.0701 25.7328 97.004 22.8811 97.004 19.8665C97.004 16.8519 99.0701 14.0002 102.88 14.0002ZM115.61 16.9333C113.26 16.9333 112.672 18.8658 112.672 19.8665C112.672 20.8672 113.26 22.7997 115.61 22.7997C117.96 22.7997 118.548 20.8394 118.548 19.8665C118.548 18.8936 117.96 16.9333 115.61 16.9333ZM115.61 14.0002C119.418 14.0002 121.485 16.8701 121.485 19.8665C121.485 22.8629 119.418 25.7328 115.61 25.7328C111.8 25.7328 109.734 22.8811 109.734 19.8665C109.734 16.8519 111.8 14.0002 115.61 14.0002Z"
            fill="#153BFC"
          />
        </svg>
        {/* mobile logo*/}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="d-block d-lg-none"
          width={48}
          height={48}
          viewBox="0 0 48 48"
          fill="none"
        >
          <path
            className="logoBG"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 27.6854 0.830673 31.1768 2.315 34.2971C3.21833 36.1961 4.36374 37.9576 5.71135 39.5418C6.28799 40.2197 6.90165 40.8651 7.5492 41.475C8.26666 42.1506 9.02572 42.7826 9.82214 43.3666C13.7946 46.2797 18.6964 48 24 48Z"
            fill="#DBE7FF"
          />
          <path
            className="logoIcon"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.8019 30.3044C15.8024 28.0802 15.794 25.8561 15.8039 23.6325C15.828 17.9506 21.9259 13.9877 27.1171 16.2746C30.6335 17.824 32.367 20.7372 32.1764 24.7777C32.0308 27.8588 29.7144 30.7927 26.4458 31.797C25.3288 32.1405 24.1022 32.2068 22.9215 32.2374C21.725 32.2685 21.6934 32.0866 21.7112 29.3559C21.7166 28.4786 21.6944 27.671 22.9561 27.7437C24.5948 27.8386 26.0766 27.4689 27.046 25.9866C27.9804 24.5567 27.9167 22.9623 26.9063 21.6065C26.0544 20.4633 24.464 19.936 23.0415 20.3249C21.5019 20.7465 20.3652 21.9757 20.3331 23.6152C20.2586 27.4437 20.2798 31.2751 20.3454 35.1041C20.3514 35.457 20.8997 36.0283 21.2808 36.1118C25.8604 37.1176 29.9123 35.9645 33.0945 32.5567C39.6366 25.5512 36.4604 15.0117 28.0278 12.1663C20.5908 9.65702 13.4144 14.4266 11.9281 21.2383C11.5254 23.0834 11.513 24.9017 11.9114 26.7423C12.0535 27.3997 12.3334 27.798 13.06 27.7382C13.9371 27.6656 14.2071 28.147 14.2041 28.9442C14.1918 32.6827 14.5427 32.1865 11.0545 32.3012C9.65958 32.3471 8.94189 31.9255 8.39005 30.5792C4.50792 21.1118 9.34664 10.2699 19.2477 7.72845C29.7667 5.02836 38.5177 10.5907 40.7226 20.8405C42.7927 30.465 35.4855 39.9279 25.695 40.7988C22.7068 41.0647 19.8982 40.5873 17.1425 39.5049C16.1943 39.1327 15.7362 38.5767 15.7757 37.4695C15.8606 35.0838 15.8014 32.6931 15.8019 30.3044Z"
            fill="#143BFF"
          />
        </svg>
      </NavLink>
      <ul className="header_right d-lg-flex d-none  order-2">
        <li className="dropdown language templat-none">
          {/*remove  data-bs-toggle="dropdown" from next button*/}
          <button
            className="btn dropdown-toggle"
            type="button"
            id="language"
            aria-expanded="false"
          >
            <img
              src="/assets/images/icons/langEarth.svg"
              className="language__earth"
              alt="earth"
            />
          </button>
          <div className="dropWrapper" aria-labelledby="language">
            <ul className="dropdown-menu">
              <li>
                <a className="dropdown-item disabled">Language</a>
              </li>
              <li>
                <a className="dropdown-item" href="#">
                  <span>Arabic</span>
                  <img
                    src="/assets/images/icons/correctBlueArrow.svg"
                    alt="selected"
                  />
                </a>
              </li>
              <li>
                <a className="dropdown-item" href="#">
                  English
                </a>
              </li>
              <li>
                <a className="dropdown-item" href="#">
                  French
                </a>
              </li>
            </ul>
          </div>
        </li>
        <li>
          <a href={`${subDomain}/contact`} className="contact_sales">
            Contact Now
          </a>
        </li>

        <li>
          <NavLink to={`/certificate`} className="contact_sales">
            Request Certificate
          </NavLink>
        </li>
        <li>
          <Link to="AppStore" className="contact_sales">
            App Store
          </Link>
        </li>

        <li onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
          {userToken ? (
            <>
              <button className="primaryBtn-2 mediumBtn btn btn_user">
                Hi,{userName}
                <span className="arrow_icon_btnUser">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="arrow"
                    width={16}
                    height={16}
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M10.4889 7C11.1538 7 11.0899 7.51535 10.7484 7.92614C10.3085 8.45519 9.03834 9.99393 8.7031 10.3442C8.18538 10.8851 7.94988 10.8854 7.43109 10.3442L5.22727 7.92614C4.89955 7.53947 4.88615 7 5.45432 7C7.4229 7 9.90105 7 10.4889 7Z"
                      fill="#fff"
                    />
                  </svg>
                </span>
              </button>
              <div className={`user_menu ${isHovered ? "show" : ""}`}>
                <ul className="user_list">
                  {showPricingPlan && (
                    <a href={`${subDomain}/ManageAccount`}>
                      <li className="onclick">
                        <div className="dropdown-item">
                          <span>Manage Account</span>
                        </div>
                      </li>
                    </a>
                  )}

                  <li className="onclick" onClick={handleLogout}>
                    <div className="dropdown-item">
                      <span>logout</span>
                    </div>
                  </li>
                </ul>
              </div>
            </>
          ) : (
            <a
              href={`${subDomain}/login`}
              className="primaryBtn-2 mediumBtn btn"
            >
              Login
            </a>
          )}
        </li>
        {/* {userToken ?
          null
          :
          <li>
            <a href={`${subDomain}/CreateAccount?page=0`} className="button_start">
              <button className="primaryBtn-1 mediumBtn  icon-r btn">
                Start now
                <img src="assets/images/icons/arrow-right16.svg" className="icon" alt="arrow" />
              </button>
            </a>
          </li>
        } */}
      </ul>
    </header>
  );
};

export default Header;
